import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 17",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.865 16.771c1.072.564 2.108-.187 1.903-1.383l-.77-4.483c.008.044 3.247-3.14 3.247-3.14.868-.846.473-2.063-.727-2.238l-4.502-.654c.044.007-1.983-4.057-1.983-4.057-.537-1.087-1.816-1.088-2.353 0L5.667 4.895c.02-.04-4.472.632-4.472.632-1.2.175-1.595 1.39-.727 2.238l3.257 3.175c-.031-.031-.78 4.448-.78 4.448-.205 1.195.83 1.948 1.903 1.383l4.027-2.117c-.04.021 3.99 2.117 3.99 2.117z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }